import React from 'react';
import Button from 'react-bootstrap/Button';

function Intro(props : any) {
    return (
      <div>
      <br /><br />

      <h3>This test will assess your OCEAN Personality Traits.</h3>
      <br />
      <h4>This is your first step towards
      increasing your self-awareness and personal effectiveness. </h4>
      <br /><br />
      <p>Please answer by being honest with yourself.</p>

      <p>It's crucial that you answer based on your current, actual self. </p>
      <p>Please don't answer based on who you wish you were or what you think the right answer is.</p>

      <p>You can select one option for each question</p>
      <br /><br />  
      <Button variant="info" size="lg" onClick={props.action}>LET'S GO!</Button>
      <br /><br />  

        </div> 
    );
  }
export default Intro;
